// The top of a list: the bar, then one button per state with its count — pressing one
// shows only those rows, pressing it again shows all — and a search over every value.
import he from '../../i18n/he';
import { ListBar, toneClass } from './ListGlance';

export default function ListToolbar({ summary, stateId, onState, query, onQuery }) {
  return (
    <div className="list-toolbar">
      <ListBar summary={summary} />
      <div className="list-toolbar-row">
        <div className="list-filters">
          <button type="button" className={`list-filter${stateId ? '' : ' on'}`} onClick={() => onState(null)}>
            {he.lists.all} <b className="num">{summary.total}</b>
          </button>
          {/* A state holding no rows has nothing to show; the one being filtered stays. */}
          {summary.states.filter((s) => s.count > 0 || s.id === stateId).map((s) => (
            <button
              key={s.id}
              type="button"
              className={`list-filter ${toneClass(s.tone)}${stateId === s.id ? ' on' : ''}`}
              onClick={() => onState(stateId === s.id ? null : s.id)}
            >
              <span className="dot" />{s.label} <b className="num">{s.count}</b>
            </button>
          ))}
        </div>
        <input
          className="search-box list-search"
          type="search"
          value={query}
          placeholder={he.lists.search}
          aria-label={he.lists.search}
          onChange={(e) => onQuery(e.target.value)}
        />
      </div>
    </div>
  );
}
